import { useMemo } from 'react';
import { filterRows } from '../utils/rowUtils';

/**
 * Custom hook for filtering table rows
 * @param {Array} rows - Table rows
 * @param {string} searchTerm - Search term
 * @param {string} optionStatus - Filter status
 * @returns {Array} - Filtered rows
 */
export function useFilteredRows(rows, searchTerm, optionStatus) {
  return useMemo(() => {
    return filterRows(rows, searchTerm, optionStatus);
  }, [rows, searchTerm, optionStatus]);
}
